// tk-footer — footer menu disclosure on mobile. Markup: <h2><button aria-expanded aria-controls>
// shown only below 750px when the footer has "Collapse menus on mobile" on. On desktop the
// plain heading text is shown and the list is always visible.
const mobile = window.matchMedia('(max-width: 749px)');

class TkFooterAccordion extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-toggle]');
    this.panel = this.querySelector('[data-panel]');
    if (!this.button || !this.panel || !this.hasAttribute('data-collapsible-mobile')) return;
    this.onChange = () => this.sync();
    this.onClick = () => this.setOpen(this.button.getAttribute('aria-expanded') !== 'true');
    mobile.addEventListener('change', this.onChange);
    this.button.addEventListener('click', this.onClick);
    this.sync();
  }

  disconnectedCallback() {
    mobile.removeEventListener('change', this.onChange);
    this.button?.removeEventListener('click', this.onClick);
  }

  sync() {
    this.toggleAttribute('data-collapsible', mobile.matches);
    this.setOpen(!mobile.matches);
  }

  setOpen(open) {
    this.button.setAttribute('aria-expanded', String(open));
    this.panel.hidden = !open;
  }
}

if (!customElements.get('tk-footer-accordion')) {
  customElements.define('tk-footer-accordion', TkFooterAccordion);
}
